import { Route, Navigate } from 'react-router-dom';
import LegacyProductionRedirect from '../components/LegacyProductionRedirect';

/** 旧 /my-plant-protection/* → canonical /production/*（由 productionRoutes 承载页面） */
export function getMyPlantProtectionRoutes() {
  return (
    <>
      <Route path="/my-plant-protection" element={<Navigate to="/production" replace />} />
      <Route path="/my-plant-protection/*" element={<LegacyProductionRedirect />} />
    </>
  );
}
